module.exports = __webpack_public_path__ + "static/img/preview-05.5b1a4eca.webp";